export default __webpack_public_path__ + "static/media/bike.a45d6676.ogg";